module.exports = __webpack_public_path__ + "img/search.6d164190.svg";